<app-page-ribbon />
<router-outlet />
